import React, { FC } from 'react';
import useWindowDimensions from '../../hooks/useWindowDimensions';

// Types
import { AdvertisementVariant, IAdvertisementProps } from '../../types';

const Advertisement: FC<IAdvertisementProps> = ({ variant, count }) => {
  // These styles will most likely be deleted after we integrate the advertisement API
  const styles = {
    alignItems: 'center',
    display: 'flex',
    margin: '0 auto',
    padding: '5px',
    height: variant === AdvertisementVariant.BOX ? '250px' : '125px',
    justifyContent: 'center',
    width: variant === AdvertisementVariant.BOX ? '300px' : '900px',
  };
  // window on mobile
  const { width } = useWindowDimensions();
  if (width < 1024) {
    styles.height = variant === AdvertisementVariant.BOX ? '250px' : '';
    styles.width = variant === AdvertisementVariant.BOX ? '300px' : '';
  }

  const adType =
    variant !== AdvertisementVariant.BOX && variant !== AdvertisementVariant.TOP
      ? `${variant}-${count}`
      : variant;

  return (
    <div
      style={styles}
      id={`dfp-ad-${adType}-wrapper`}
      // itemID={`${count}`}
      className="dfp-tag-wrapper dfp-basstrakk"
    >
      <div id={`dfp-ad-${adType}`} className={`dfp-tag-wrapper ${variant}`} />
    </div>
  );
};

export default Advertisement;
